import { Injectable } from "@angular/core";
import { BaseService } from "@dmms/core/http";
import { Observable } from "rxjs";
import {
  IApiResponse,
  IApiResponsePagination,
} from "@models/http/http-options";
import { DataAvailabilityQueryParameterEnum } from "@models/dictionary/dic-base";
import { InterfaceManagementEndpoints } from "../types/interface-management-endpoints";
import {
  IGridPage,
  IGridPageParams,
  IGridScreenParams,
  IGridWidget,
  IGridWidgetParams,
} from "../models/grid";
import { IGuideResponse } from "@models/interface-management/guide";
import { IPagination } from "@models/core/pagination";

/**
 * Interface Management API Service
 * Сервис для работы с API микросервиса interface-management
 */
@Injectable({
  providedIn: "root",
})
export class InterfaceManagementApiService extends BaseService {
  getGrids(
    url: string,
    version: number = 1,
    dataAvailabilityQueryParameter: DataAvailabilityQueryParameterEnum = DataAvailabilityQueryParameterEnum.NotDeleted,
  ): Observable<IApiResponsePagination<IGridPage[]>> {
    return this.get(`v${version}/${InterfaceManagementEndpoints.Grids}`, {
      url,
      dataAvailabilityQueryParameter,
    });
  }

  createGridPage(
    data: IGridPageParams,
    version: number = 1,
  ): Observable<IApiResponse<string>> {
    return this.post(
      `v${version}/${InterfaceManagementEndpoints.GridPages}`,
      data,
    );
  }

  createGridScreen(
    pageId: string,
    screenSize: IGridScreenParams,
    version: number = 1,
  ): Observable<IApiResponse<string>> {
    return this.post(
      `v${version}/${InterfaceManagementEndpoints.GridPageById.replace("{pageId}", pageId)}`,
      screenSize,
    );
  }

  createWidget(
    screenId: string,
    data: IGridWidgetParams,
    version: number = 1,
  ): Observable<IApiResponse<{ widgetId: string; screenWidgetId: string }>> {
    return this.post(
      `v${version}/${InterfaceManagementEndpoints.GridScreens.replace("{screenId}", screenId)}`,
      data,
    );
  }

  editWidget(
    widgetId: string,
    screenWidgetId: string,
    data: Partial<IGridWidget>,
    version: number = 1,
  ): Observable<IApiResponse<{ widgetId: string; screenWidgetId: string }>> {
    return this.put(
      `v${version}/${InterfaceManagementEndpoints.GridWidgets.replace("{widgetId}", widgetId).replace("{screenWidgetId}", screenWidgetId)}`,
      data,
    );
  }

  deleteWidget(
    id: string,
    version: number = 1,
  ): Observable<IApiResponse<void>> {
    return this.remove(
      `v${version}/${InterfaceManagementEndpoints.RelGridScreenWidgets.replace("{id}", id)}`,
    );
  }

  getMyGuides(
    params: IPagination,
    version = 1,
  ): Observable<IApiResponsePagination<IGuideResponse[]>> {
    return this.get<IApiResponsePagination<IGuideResponse[]>>(
      `v${version}/${InterfaceManagementEndpoints.MyGuide}`,
      params,
    );
  }
}
